import React from "react";
import { Link, useLocation } from "react-router-dom";
import { 
  Home, Users, Target, Flame, Rocket, BarChart3, 
  Plus, User, MessageCircle, ExternalLink, Settings,
  Trophy, Shield, UserPlus, Crown
} from "lucide-react";
import { DISCORD_INVITE, UEX_REFERRAL } from "../../constants";
import { useApp } from "../../contexts/AppContext";

// Super admin wallets - hardcoded for reliability
const SUPER_ADMIN_WALLETS = [
  "addr1q9ux67lgxrejk752rtwr9gkm24lrthr3td7k7yexq7ms59tqrg557stwp8hwd5eclku7t6wq46gc72na8fwgj22c8e5qurvush",
  "addr1qxc6u2d5ppeuhg7tkj5quf3csxp2022g98az65hpad9m6yreuxes6p3hhg880tegsg95xqwek6srgac5jq04x9rcm2qq6a6md7"
];

export const LeftSidebar = () => {
  const location = useLocation();
  const { user } = useApp();
  
  // Check if user is admin - check wallet directly as fallback
  const walletAddress = user?.wallet_address || '';
  const isWalletSuperAdmin = SUPER_ADMIN_WALLETS.includes(walletAddress);
  const isAdmin = user?.is_admin === true || user?.is_superadmin === true || isWalletSuperAdmin;
  
  // Debug logging for admin status
  console.log('[BURNZ DEBUG] LeftSidebar - user:', user);
  console.log('[BURNZ DEBUG] LeftSidebar - isAdmin check:', { 
    walletAddress, 
    isWalletSuperAdmin, 
    userIsAdmin: user?.is_admin, 
    userIsSuperAdmin: user?.is_superadmin,
    finalIsAdmin: isAdmin 
  });
  
  const navItems = [
    { path: "/app", label: "Dashboard", icon: Home },
    { path: "/app/teams", label: "Team Cards", icon: Shield, highlight: true },
    { path: "/app/quests", label: "Quests", icon: Target },
    { path: "/app/rewards", label: "Rewards", icon: Trophy },
    { path: "/app/dump", label: "Dump Zone", icon: Flame },
    { path: "/app/referrals", label: "Referrals", icon: UserPlus, highlight: true },
    { path: "/app/campaign-studio", label: "Campaign Studio", icon: Rocket },
    { path: "/app/impact", label: "Impact", icon: BarChart3 },
    { path: "/app/request", label: "Request Team", icon: Plus },
  ];

  return (
    <aside className="w-48 bg-surface-1 border-r border-theme-10 flex flex-col py-4 fixed left-0 top-16 bottom-0 z-40">
      <nav className="space-y-1 px-2">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link key={item.path} to={item.path} className={`flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all relative ${isActive ? "bg-purple-500/20 text-purple-400" : item.highlight ? "text-purple-400 hover:bg-purple-500/10" : "text-theme-secondary hover:bg-surface-opacity-5 hover:text-theme-primary"}`}>
              {isActive && <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-6 bg-purple-500 rounded-r" />}
              <item.icon className="w-5 h-5" />
              <span className="text-sm font-medium">{item.label}</span>
              {item.highlight && !isActive && <span className="ml-auto text-[9px] bg-purple-500/20 text-purple-400 px-1.5 py-0.5 rounded">NEW</span>}
            </Link>
          );
        })}
      </nav>
      
      <div className="mt-auto px-2 space-y-1">
        {/* Admin/Superadmin Command Center Link - Hidden from regular users */}
        {isAdmin && (
          <Link to="/command-center" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-red-400 hover:bg-red-500/10 border border-red-500/20">
            <Settings className="w-5 h-5" />
            <span className="text-sm font-medium">Command</span>
          </Link>
        )}
        
        <Link to="/app/profile" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-theme-secondary hover:bg-surface-opacity-5 hover:text-theme-primary">
          <User className="w-5 h-5" />
          <span className="text-sm font-medium">Profile</span>
        </Link>
        <a href={DISCORD_INVITE} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-[#5865F2] hover:bg-[#5865F2]/10">
          <MessageCircle className="w-5 h-5" />
          <span className="text-sm font-medium">Discord</span>
        </a>
        <a 
          href={UEX_REFERRAL} 
          target="_blank" 
          rel="noopener noreferrer" 
          className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-cyan-400 hover:bg-cyan-500/10"
        >
          <ExternalLink className="w-5 h-5" />
          <span className="text-sm font-medium">UEX.us</span>
        </a>
      </div>
    </aside>
  );
};
